export const REGEX_EMAIL
  = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}|[a-zA-Z]+\.[a-zA-Z]{2,3}))$/

export const REGEX_URL = /(https?:\/\/[^\s]+)/g
export const REGEX_ALPHA = /^[-a-zA-ZÀ-ÿ ]*$/

export const REGEX_PASSWORD = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[&^%*$!@#]).*$/
